/**
 * Fut-e éppen a build-idejű prerender (puppeteer)?
 *
 * A prerender a `NorbiPhonePrerender` User-Agenttel megy, és a TELJES megrendelt
 * DOM-ot menti (`page.content()`) – vagyis a `useEffect`-ek is lefutnak, mielőtt
 * a HTML kisül. Ezért minden IDŐFÜGGŐ állapot (nyitva/zárva) a build pillanatát
 * égetné a statikus oldalba: egy hajnali build után a látogató délelőtt is a
 * „zárva” változatot látná az első festéskor, amíg a JS be nem tölt.
 *
 * A megoldás: prerender alatt maradjon az alapértelmezett (nyitva) változat, a
 * valós állapotot a kliens állítja be hidráció után.
 */
export const isPrerender = () =>
  typeof navigator !== 'undefined' && /NorbiPhonePrerender/i.test(navigator.userAgent || '');

export default isPrerender;
